import React from 'react';
import PropTypes from 'prop-types';
import { FaWindowClose } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import {
  ModalBackdrop,
  ModalContent,
  ModalHeader,
  CloseButton,
  TabContent,
  SuccessMessage,
  ModalFooter,
  AllMargin,
  CancelButton,
  ContinueButton,
} from "./FeedbackModalStyles";

function FeedbackSuccessModal({ feedbackId, onClose, onAddAnother }) {
  const { t } = useTranslation('feedbackSuccess')

  return (
    <ModalBackdrop>
      <ModalContent>
        <ModalHeader>
          <h2>{t('title')}</h2>
          <CloseButton onClick={onClose}>
            <FaWindowClose />
          </CloseButton>
        </ModalHeader>

        <TabContent>
          <SuccessMessage>
            <p>{t('successLine1', { id: feedbackId })}</p>
            <p>{t('successLine2')}</p>
          </SuccessMessage>
        </TabContent>

        <AllMargin>
          <ModalFooter>
            <CancelButton type="button" onClick={onClose}>
              {t('closeButton')}
            </CancelButton>
            <ContinueButton type="button" onClick={onAddAnother}>
              {t('addAnotherButton')}
            </ContinueButton>
          </ModalFooter>
        </AllMargin>
      </ModalContent>
    </ModalBackdrop>
  );
}

FeedbackSuccessModal.propTypes = {
  feedbackId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClose: PropTypes.func.isRequired,
  onAddAnother: PropTypes.func.isRequired,
};

export default FeedbackSuccessModal;
